import React, { useEffect, useRef, useState } from 'react'

const OptionalContentImage = ({ src }) => {
    const [open, setOpen] = useState(false);
    const [zoomed, setZoomed] = useState(false);
    const imageRef = useRef(null);
    const overlayRef = useRef(null);
    const fittedWidth = useRef(0);
    const openedAt = useRef(0);

    useEffect(() => {
        if (!open || !zoomed || !overlayRef.current) {
            return;
        }
        const overlay = overlayRef.current;
        overlay.scrollLeft = Math.max(0, (overlay.scrollWidth - overlay.clientWidth) / 2);
        overlay.scrollTop = Math.max(0, (overlay.scrollHeight - overlay.clientHeight) / 2);
    }, [open, zoomed]);

    if (!src || (typeof src === 'string' && src.trim() === '')) {
        return null;
    }

    const close = (event) => {
        event.stopPropagation();
        setOpen(false);
        setZoomed(false);
    };

    const toggleZoom = (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (!zoomed && imageRef.current) {
            fittedWidth.current = imageRef.current.clientWidth;
        }
        setZoomed((value) => !value);
    };

    return (
        <>
            <img
                src={src}
                alt=""
                onClick={() => {
                    openedAt.current = Date.now();
                    setZoomed(false);
                    setOpen(true);
                }}
                style={{ width: "100%", maxWidth: "320px", height: "auto", marginTop: "8px", marginBottom: "4px", borderRadius: "8px", display: "block", cursor: "pointer" }}
            />
            {open && (
                <div
                    ref={overlayRef}
                    onClick={(event) => {
                        if (Date.now() - openedAt.current < 400) {
                            return;
                        }
                        close(event);
                    }}
                    style={{
                        position: "fixed",
                        inset: 0,
                        overflow: "auto",
                        backgroundColor: "rgba(0, 0, 0, 0.85)",
                        zIndex: 2000,
                        display: zoomed ? "block" : "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "56px 16px 16px",
                    }}
                >
                    <button
                        type="button"
                        aria-label="Chiudi"
                        onClick={close}
                        style={{
                            position: "fixed",
                            top: "16px",
                            right: "16px",
                            zIndex: 2001,
                            width: "44px",
                            height: "44px",
                            borderRadius: "22px",
                            border: "none",
                            backgroundColor: "#FDB933",
                            color: "#7C112B",
                            fontSize: "28px",
                            lineHeight: "44px",
                            fontFamily: "Merriweather",
                            cursor: "pointer",
                            padding: 0,
                        }}
                    >
                        ×
                    </button>
                    <img
                        ref={imageRef}
                        src={src}
                        alt=""
                        onClick={(event) => event.stopPropagation()}
                        onDoubleClick={toggleZoom}
                        style={{
                            maxWidth: zoomed ? "none" : "92vw",
                            maxHeight: zoomed ? "none" : "85vh",
                            width: zoomed ? fittedWidth.current * 2 : "auto",
                            height: "auto",
                            marginLeft: zoomed ? "auto" : undefined,
                            marginRight: zoomed ? "auto" : undefined,
                            borderRadius: "8px",
                            display: "block",
                            flexShrink: 0,
                            cursor: zoomed ? "zoom-out" : "zoom-in",
                        }}
                    />
                </div>
            )}
        </>
    )
}

export default OptionalContentImage
